/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_Page_LeadInputs */

const en_pol_page_lead = /** @type {(inputs: Pol_Page_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep only uses paths AI providers allow. This table shows every provider in five ways of use, when we last checked, and the source.`)
};

const id_pol_page_lead = /** @type {(inputs: Pol_Page_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep hanya memakai jalur yang diizinkan penyedia AI. Tabel ini menunjukkan tiap penyedia di lima cara pakai, kapan terakhir kami cek, dan sumbernya.`)
};

/**
* | output |
* | --- |
* | "Bystep only uses paths AI providers allow. This table shows every provider in five ways of use, when we last checked, and the source." |
*
* @param {Pol_Page_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_page_lead = /** @type {((inputs?: Pol_Page_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_Page_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_page_lead(inputs)
	return en_pol_page_lead(inputs)
});